import Vue from 'vue'
import VueRouter from 'vue-router'
import Layout from '@/components/Layout/index.vue'
import home from "./home"    //首页
import workflow from "./workflow"   //工作流
import invoiceClip from "./invoiceClip"   //发票夹
import setting from "./setting"   //设置
import store from "@/store/index"
import Cookies from "js-cookie"

let api = require("@/api/api")

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Layout,
    meta:{},
    children:[
      ...home,
      ...workflow,
      ...invoiceClip,
      ...setting
    ],
  },
  // {
  //   path:"/login",
  //   name:"login",
  //   component:()=>import("@/views/login/login.vue"),
  //   meta:{},
  // }
]

const router = new VueRouter({
  routes
})
router.beforeEach((to,from,next)=>{
  // console.log(to.path)
  if(to.path == "/"){
    next("/home")
  }
  const token = Cookies.get("payapp_token");
  const not404 = to.path !== '/no404/' && to.path !== '/no404';
  if(to.path == "/home/" || to.path == "/home"){
    console.log("/home/")
    let str = window.location.href.split('?')[1]
    let code = ""
    if(str){
      let a = str.split("&")[0]
      if(a){
        code = a.split("=")[1]
      }
    }
    if(code){
      // console.log(code)
      store.commit("login",code)
      // if(!Cookies.get("payapp_token")){
      //   api.post("/payment/auth/user/noauth/qywx/login", {
      //     reqData: {
      //       code: token,
      //     },
      //   }).then(res=>{
      //     if(res.repCode == '0000'){
      //       Cookies.set("payapp_token",res.repData.token)
      //       store.commit("setToken",res.repData.token)
      //       Cookies.set("payapp_companyId",res.repData.companyId)
      //       Cookies.set("payapp_userInfo",res.repData)
      //     }
      //   })
      // }
    } else {
      next('/no404');
    }
  } else if (!token && not404) {
    next('/no404');
  }
  next()
})

export default router
